const promises = {};
export default class AsyncScriptService {
  static load(paths, requirables) {
    if(!Array.isArray(paths) && paths) { paths = [ paths ]; }
    if(!Array.isArray(requirables) && requirables) { requirables = [ requirables ]; }
    const requireable = window.require.list();
    const queue = [];

    paths.forEach(path => {
      // path example: { http: 'javascripts/blocks/modal.js', require: 'views/block/modal-view'}
      const scriptTag = document.querySelector(`script[src="${path.http}"]`);
      if(!requireable.includes(path.require)) {
        if(scriptTag === null) {
          const script = document.createElement('script');
          script.src = path.http;
          script.async = path.async || false;
          promises[path.http] = new Promise((resolve) => {
            script.onload = (e) => {
              path.event = e;
              resolve(path);
            };
          });
          queue.push(promises[path.http]);
          document.body.appendChild(script);
        } else {
          //if script tag is present, we should have a promise available
          queue.push(promises[path.http]);
        }
      } else {
        // Note: this fake promise must be here to preserve the order of the arguments
        queue.push(new Promise((resolve) => resolve(path) ));
      }
    });

    // Note Promise.all preserves order, this is important for the arguments to line up
    return Promise.all(queue).then((loaded) => {
      if(requirables && requirables.length > 0) {
        return Promise.resolve(requirables.map(path => {
          return window.require(path);
        }));
      } else {
        return Promise.resolve(loaded.map(path => {
          return window.require(path.require);
        }));
      }
    });
  }
}
